import React from "react";

export function Footer() {
    return <div className="footer">
        <div className="footer-links">
            &copy; Copyright Wayf.re 2025
        </div>
        <div className="footer-brand">
            <p className="footer-brand-name">
                <strong>wayfare</strong> <em>noun</em>
            </p>
            <p className="footer-brand-pronunciation">
                way·​fare ˈwāˌfa(a)|(ə)r, -ˌfe|, |ə
            </p>
            <p className="footer-brand-definition">
                <strong>archaic:</strong> an act or course of journeying
            </p>
        </div>
    </div>
}
